<div class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0 lg:overflow-hidden">
    <div class="flex space-x-2 items-center">
        <!-- search -->
        <div class="min-w-48 relative">
            <input [(ngModel)]="search" class="pl-8" type="text" placeholder="Search.." />
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
        </div>
        <div>
            <ng-select class="w-[240px]" [ngModelOptions]="{standalone: true}" [items]="statusList" bindLabel="label"
                bindValue="value" (ngModelChange)="onStatusChange($event)" [(ngModel)]="selectedStatus" [multiple]="true"
                [clearable]="false" [closeOnSelect]="false" placeholder="Select Status" [searchable]="true">
        
                <!-- Custom Checkbox for Each Item -->
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" type="checkbox" [disabled]="item.disabled" [ngModelOptions]="{standalone: true}"
                        [ngModel]="selectedStatus.includes(item.value)" />
                    {{ formatToTitleCase(item.label) }}
                </ng-template>
        
                <!-- Custom Selected Labels -->
                <ng-template ng-multi-label-tmp let-items="items">
                    <div class="ng-value" *ngIf="items.length > 0">
                        <span class="ng-value-label">{{items[0].label}}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{ items.length - 1 }} more</span>
                    </div>
                </ng-template>
        
            </ng-select>
        </div>
        

        <div>
            <div>
              <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date" (ngModelChange)="onDateChange($event)"
                [owlDateTimeTrigger]="date" [selectMode]="'range'" [readOnly]="true" />
              <owl-date-time [pickerType]="'calendar'"  #date></owl-date-time>
            </div>
          </div>

          <div class="">
            <flx-circle-timer class="countDownTimer" #timer color="#40337f" [duration]="duration"
              (onComplete)="onTimerComplete()"></flx-circle-timer>
          </div>

    </div>
    
    <div *ngIf="selectedStatus" class="flex flex-1 overflow-x-auto gap-2">
         <!-- Schedule -->
         <div *ngFor="let item of selectedStatus"  class="overflow-hidden w-96 h-full flex flex-col flex-shrink-0 rounded-md border border-zinc-950/10 dark:border-white/10">
            <div class="p-2">
                <div class="flex items-center gap-2">
                    <h2 class="subheading">
                        <!-- {{(item.charAt(0).toUpperCase() + item.slice(1)).replace('_', ' ')}} -->
                         {{(item.charAt(0).toUpperCase() + item.slice(1)).replace('_', ' ')}}
                        <!-- {{capitalizeLabels(item)}} -->
                        <span class="badge-primary dark:badge-secondary" >{{allTrips && allTrips[item]?.length ? allTrips[item]?.length : '0'}}</span>
                    </h2>
                </div>
            </div>
            <ng-container *ngIf="allTrips && allTrips[item]">
            <div class="overflow-y-auto">
            <app-trip-card
            [selectedStatus]="item"
             [trips]="allTrips[item]"
             [searchTerm]="search"
             [preLevelOfService]="preLevelOfService"
             [preSpacetypes]="preSpacetypes"
             (memberNotesObj)="openNotesModal($event)"
             (tripDetails)="opendetailModal($event)"
             ></app-trip-card>
            </div>
            </ng-container>
        </div>
    </div>
</div>


<app-notes-modal *ngIf="memberNotesObj" [notes]="memberNotesObj"
  (closeModal)="memberNotesObj = null"></app-notes-modal>
<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" (closeModal)="tripId = null"></app-trip-detail-modal>
